import { Line, Component } from "../Engine";
import { SoccerPlaygroundConfig } from "./";

export class SideLines extends Component {

    goalLineTop: Line | undefined;
    goalLineBottom: Line | undefined;
    sideLineLeft: Line | undefined;
    sideLineRight: Line | undefined;

    constructor(public config: SoccerPlaygroundConfig) {
        super();

        this.initialize();
    }
    initialize() {
        this.goalLineTop = new Line(this.config.topLeftCorner, this.config.topRightCorner);
        this.goalLineBottom = new Line(this.config.bottomLeftCorner, this.config.bottomRightCorner);
        this.sideLineLeft = new Line(this.config.topLeftCorner, this.config.bottomLeftCorner);
        this.sideLineRight = new Line(this.config.topRightCorner, this.config.bottomRightCorner);

        this.children.push(this.goalLineTop,
            this.goalLineBottom,
            this.sideLineLeft,
            this.sideLineRight
        );
    }
}

